import { css } from "../../helpers/webComponents";

export const planterMiniGameStyles: string = css`
    :host {
        display: block;
        font-family: "Onesize";
        max-width: 500px;
        margin: 0 auto;
        padding: 15px;
        background-color: #2a1a47;
        border: 2px solid #413063;
        border-radius: 10px;
        color: white;
    }

    .title {
        text-align: center;
        font-size: 1.2em;
        margin-bottom: 15px;
        color: #7f6ed7;
    }

    .description {
        text-align: center;
        margin-bottom: 15px;
        color: #ccc;
    }

    .water-level-container {
        height: 30px;
        background: #1e1435;
        border: 1px solid #413063;
        border-radius: 15px;
        overflow: hidden;
        margin-bottom: 15px;
        position: relative;
    }

    .water-level {
        height: 100%;
        background: linear-gradient(to right, #3498db, #7f6ed7);
        width: 0%;
        transition: width 0.3s ease;
    }

    .water-level-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-weight: bold;
    }

    .plant-container {
        display: flex;
        justify-content: center;
        margin: 15px 0;
    }

    .plant {
        width: 150px;
        height: 150px;
        background-image: url('/assets/img/rooms/plant-dry.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        transition: all 0.5s ease;
    }

    .plant.watered {
        background-image: url('/assets/img/rooms/plant-watered.png');
    }

    .watering-can {
        width: 80px;
        height: 80px;
        background-image: url('/assets/img/rooms/watering-can.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        margin: 0 auto;
        display: block;
    }

    .watering-can:hover {
        transform: scale(1.1);
    }

    .button {
        background-color: #7f6ed7;
        border: none;
        color: white;
        padding: 10px 20px;
        text-align: center;
        font-size: 16px;
        margin: 10px auto;
        cursor: pointer;
        border-radius: 5px;
        display: block;
    }

    .button:hover {
        background-color: #9a8ae8;
    }

    .success-message {
        color: #2ecc71;
        text-align: center;
        margin: 15px 0;
        font-weight: bold;
        display: none;
    }
`;
